import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

const useStrategicContext = (orgId: string | null | undefined) => {
  return useQuery({
    queryKey: ['strategic_contexts', orgId],
    queryFn: async () => {
      const { data, error } = await supabaseClient
        .from('strategic_contexts')
        .select('id')
        .eq('org_id', orgId!)
        .maybeSingle();
      if (error) throw new Error(error.message);
      return data;
    },
    enabled: !!orgId,
  });
};

export default useStrategicContext;
